import React from 'react'
import PropTypes from 'prop-types'
import { getColor } from 'src/styles'
import styles from './BigCalendarEvent.scss'

const BigCalendarEvent = ({ event }) => (
  <div className={styles.event} style={{ backgroundColor: getColor(event.color) }}>
    <strong>{event.title}</strong>
  </div>
)

BigCalendarEvent.propTypes = {
  event: PropTypes.shape({
    title: PropTypes.string,
    color: PropTypes.string,
  }),
}

export default BigCalendarEvent
